// Can use as const when typescript is updated past 3.4
// Used to narrow type to its literal value when passed into things like Object.values
// otherwise the output of Object.values would be string[] instead of ('a' | 'b')[] for example
export const experiments = {
  b2c_046_donate_button_prominence: 'b2c_046_donate_button_prominence' as 'b2c_046_donate_button_prominence',
  b2c_047_donate_button_text: 'b2c_047_donate_button_text' as 'b2c_047_donate_button_text',
  b2c_interstitial_option_copy_change: 'b2c_interstitial_option_copy_change' as 'b2c_interstitial_option_copy_change',
};

export type ExperimentKeys = keyof typeof experiments;



// WEBPACK FOOTER //
// ./src/constants/experiments.ts